module.exports = __webpack_public_path__ + "img/lets-do-this.a96a93d5.png";